import { animated, useSpring } from "@react-spring/web";
import React from "react";

const AirplaneIcon = () => {
  const movement = 20;
  const animation = useSpring({
    from: {
      transform: `translateY(-${movement}px)`,
    },
    to: [
      { transform: `translateY(${movement}px)` },
      { transform: `translateY(-${movement}px)` },
    ],
    config: {
      duration: 600,
    },
    // reset: true,
    // reverse: true,
    loop: true,
  });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="284"
      fill="none"
      viewBox="0 -20 308 312"
    >
      <path
        fill="#FFEFD8"
        fillRule="evenodd"
        d="M229.432 288c-14.456 0-26.182-12.043-26.182-26.889v-152.02h52.364v152.02c0 14.846-11.726 26.889-26.182 26.889z"
        clipRule="evenodd"
        opacity="0.7"
      ></path>
      <path
        fill="#FFEFD8"
        d="M50.527 109.091h53.819v152.02c0 14.846-12.052 26.889-26.91 26.889-14.857 0-26.909-12.043-26.909-26.889v-152.02z"
        opacity="0.7"
      ></path>
      <animated.path
        style={animation}
        fill="#5AB2D0"
        d="M213.19 133.948c5.271 0 9.541-4.335 9.541-9.689V71.165h-19.083v53.094c0 5.354 4.27 9.689 9.542 9.689zM246.842 141.725c5.271 0 9.541-4.336 9.541-9.689V86.377h-19.082v45.659c0 5.353 4.269 9.689 9.541 9.689z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#2F3F59"
        d="M161.329 51.932l-13.977 54.791 159.719 38.828v-27.662L161.329 51.932z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#FD9401"
        d="M237.301 86.329h19.082l-4.389-9.931h-11.759l-2.934 9.93zM203.648 71.165h19.083l-4.389-9.932h-11.76l-2.934 9.932z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#EE5040"
        d="M150.401 182.829l-34.229 15.502v27.638l34.229-8.333v-34.807zM157.777 182.829l34.229 15.502v27.638l-34.229-8.333v-34.807z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#5AB2D0"
        d="M94.881 133.948c-5.272 0-9.541-4.335-9.541-9.689V71.165h19.082v53.094c0 5.354-4.269 9.689-9.541 9.689zM61.225 141.725c-5.272 0-9.541-4.336-9.541-9.689V86.377h19.082v45.659c0 5.353-4.27 9.689-9.541 9.689z"
      ></animated.path>
      <animated.path
        fill="#2F3F59"
        style={animation}
        d="M146.738 51.932l13.954 54.791L.996 145.551v-27.662l145.742-65.957z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#FD9401"
        d="M70.742 86.329H51.684l4.389-9.931h11.76l2.91 9.931zM104.398 71.165H85.34l4.389-9.932h11.759l2.91 9.932z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#5AB2D0"
        d="M154.549 219.636a8.154 8.154 0 01-7.861-6.062l-2.153-8.1a334.606 334.606 0 01-11.101-85.507v-98.82c0-11.69 9.432-21.147 21.09-21.147 11.659 0 21.091 9.458 21.091 21.146v98.821c0 28.882-3.724 57.619-11.101 85.531l-2.129 8.076a8.133 8.133 0 01-7.861 6.062h.025z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#0092B1"
        d="M153.797.024c-11.235.025-20.363 9.481-20.363 21.144v98.81c0 28.855 3.604 57.613 10.743 85.498l2.083 8.098c.913 3.565 4.003 6.038 7.537 6.062V0v.024z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#2F3F59"
        d="M162.529 24.727h-2.677v-8.676c0-3.904-2.721-7.094-6.051-7.094-3.329 0-6.05 3.19-6.05 7.094v8.676h-2.677v-8.676c0-5.64 3.918-10.233 8.727-10.233 4.81 0 8.728 4.593 8.728 10.233v8.676zM153.796 248.727c-1.608 0-2.909-1.646-2.909-3.679v-87.187c0-2.033 1.301-3.679 2.909-3.679 1.607 0 2.909 1.646 2.909 3.679v87.187c0 2.033-1.302 3.679-2.909 3.679z"
      ></animated.path>
      <animated.path
        style={animation}
        fill="#fff"
        d="M140.844 82.79c0-5.062 3.888-8.816 9.183-8.816s9.184 3.73 9.184 8.817c0 5.086-3.912 8.817-9.184 8.817-5.271 0-9.183-3.755-9.183-8.817zm14.455 0c0-3.245-2.266-5.45-5.248-5.45s-5.248 2.23-5.248 5.45c0 3.222 2.266 5.45 5.248 5.45s5.248-2.228 5.248-5.45zM167.345 74.264v17.052h-3.888V77.413h-3.363V74.24h7.251v.024z"
      ></animated.path>
      <path
        // style={animation}
        stroke="#2F3F59"
        strokeMiterlimit="10"
        d="M56.37 24.682H22.547M39.465 41.856V7.509M273.3 236.601h-33.823M256.395 253.774v-34.347"
      ></path>
    </svg>
  );
};

export default AirplaneIcon;
